import * as React from 'react';
import { Icon } from 'semantic-ui-react';

export class OnlineIcon extends React.Component {
  public render() {
    return <Icon name="circle" color="green" />;
  }
}


// WEBPACK FOOTER //
// ./src/components/connection-status/online-icon.tsx